export default function BrevetLevelAGradeText({text}) {
    // Used in

    // BUILD
    return (
        <div className={"flex justify-start items-center"}>
            <span className={"text-[14px] font-normal text-greyLight7"}>
                {text}
            </span>
        </div>

    );
}